// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1_jjZ","label":"Radio_label__1naFM","checkMark":"Radio_checkMark__3HjoF","disabled":"Radio_disabled__fIMSO"};